import { Button, Stack } from "@mui/material";
import React from "react";
import { useHistory } from "react-router-dom";
import { HouseLine } from "@phosphor-icons/react/dist/ssr";
import { ArrowLeft } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

export default function Container({
  children,
  showGoHome,
  onBack,
}: {
  children: React.ReactNode;
  showGoHome?: boolean;
  onBack?: () => void;
}) {
  const { t } = useTranslation(["rescheduling"]);
  const history = useHistory();
  return (
    <Stack
      alignItems="center"
      minHeight="100vh"
      px="24px"
      pb="64px"
      pt={{ xs: "64px", sm: "128px" }}
      overflow="auto"
    >
      <Stack maxWidth="512px" width="100%" gap={11} flexShrink={0}>
        {showGoHome && (
          <Button
            variant="text"
            size="small"
            color="secondary"
            startIcon={<HouseLine weight="duotone" />}
            sx={{ width: "fit-content" }}
            onClick={() => history.push("/dashboard")}
          >
            {t("rescheduling:common.goHome")}
          </Button>
        )}
        {onBack && (
          <Button
            variant="text"
            size="small"
            color="secondary"
            startIcon={<ArrowLeft />}
            sx={{ width: "fit-content" }}
            onClick={onBack}
          >
            {t("rescheduling:common.back")}
          </Button>
        )}
        {children}
      </Stack>
    </Stack>
  );
}
